import { render, staticRenderFns } from "./ModalMandatos.vue?vue&type=template&id=08f506c1&scoped=true"
import script from "./ModalMandatos.vue?vue&type=script&lang=js"
export * from "./ModalMandatos.vue?vue&type=script&lang=js"
import style0 from "./ModalMandatos.vue?vue&type=style&index=0&id=08f506c1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f506c1",
  null
  
)

export default component.exports